import { useState } from "react";
import { formatJPY } from "@juro/shared";
import { WorkItemRow } from "./WorkItemRow.js";
import type { WorkItem, WorkItemInput } from "../../api/workItemsApi.js";
import { PROFESSION_LABEL, PROFESSION_COLOR } from "../../lib/workItemConstants.js";

type Props = {
  profession: string;
  items:      WorkItem[];
  onUpdate:   (id: string, patch: Partial<WorkItemInput>) => void;
  onDelete:   (id: string) => void;
  onDuplicate: (item: WorkItem) => void;
};

export function WorkItemGroup({ profession, items, onUpdate, onDelete, onDuplicate }: Props) {
  const [open, setOpen] = useState(true);

  const feeTotal = items
    .filter((i) => !i.is_pass_through)
    .reduce((s, i) => s + i.amount, 0);

  const color = PROFESSION_COLOR[profession] ?? "#475569";
  const label = PROFESSION_LABEL[profession] ?? profession;

  return (
    <div style={{ marginBottom: 8 }}>
      {/* グループヘッダー */}
      <button
        onClick={() => setOpen(!open)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          width: "100%",
          background: `${color}10`,
          border: "none",
          borderRadius: 8,
          padding: "8px 12px",
          cursor: "pointer",
          textAlign: "left",
        }}>
        <span style={{
          background: `${color}20`,
          color,
          borderRadius: 99,
          padding: "2px 10px",
          fontSize: 12,
          fontWeight: 700,
        }}>
          {label}
        </span>
        <span style={{ fontSize: 12, color: "#475569" }}>
          {items.length}件 / {formatJPY(feeTotal)}
        </span>
        <span style={{ marginLeft: "auto", color: "#94a3b8", fontSize: 12 }}>
          {open ? "▲" : "▼"}
        </span>
      </button>

      {/* テーブル */}
      {open && (
        <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 2 }}>
          <thead>
            <tr style={{ background: "#f8fafc" }}>
              <th style={th}></th>
              <th style={th}>業務名</th>
              <th style={{ ...th, textAlign: "right" }}>数量</th>
              <th style={{ ...th, textAlign: "right" }}>単価</th>
              <th style={{ ...th, textAlign: "right" }}>金額</th>
              <th style={th}>税区分</th>
              <th style={{ ...th, textAlign: "center" }}>源泉</th>
              <th style={{ ...th, textAlign: "center" }}>立替</th>
              <th style={th}>カテゴリ</th>
              <th style={th}></th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <WorkItemRow
                key={item.id}
                item={item}
                onUpdate={onUpdate}
                onDelete={onDelete}
                onDuplicate={onDuplicate}
              />
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

const th: React.CSSProperties = {
  padding: "5px 8px",
  fontSize: 11,
  color: "#94a3b8",
  fontWeight: 600,
  textAlign: "left",
  borderBottom: "1px solid #e2e8f0",
};
